export const setFont = (font) =>
  (document.getElementById('root').style.fontFamily = font || 'Monserrat')
